import React, { useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';

// Faz o menu ter exatamente a largura do campo (mesmo com strategy: 'fixed')
const sameWidthModifier = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ state }) => {
    state.styles.popper.width = `${state.rects.reference.width}px`;
  },
  effect: ({ state }) => {
    state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
  },
};

/**
 * Dropdown estilizado como um <select> da marca Biotrop — sem o azul nativo
 * do sistema operacional. Drop-in para filtros/seletores simples.
 *
 * Props:
 *  - value:       valor atual (string ou number)
 *  - onChange:    (value: string) => void   // recebe o valor já (não o event)
 *  - options:     [{ value, label }]
 *  - placeholder, size ('sm'), disabled, className, style, menuAlign
 *  - searchable:  mostra um campo de busca no topo do menu (listas longas)
 *  - searchPlaceholder, noResultsText: textos do modo busca
 */
export default function BrandSelect({
  value,
  onChange,
  options = [],
  placeholder = '',
  size,
  disabled = false,
  className = '',
  style,
  menuAlign,
  searchable = false,
  searchPlaceholder = 'Buscar…',
  noResultsText = 'Nada encontrado',
}) {
  const [query, setQuery] = useState('');
  const selected = options.find((o) => String(o.value) === String(value));
  const label = selected ? selected.label : placeholder;

  const filtered = searchable && query.trim()
    ? options.filter((o) => String(o.label).toLowerCase().includes(query.trim().toLowerCase()))
    : options;

  return (
    <Dropdown
      className={className}
      onSelect={(val) => onChange && onChange(val)}
      onToggle={(isOpen) => { if (!isOpen) setQuery(''); }}
    >
      <Dropdown.Toggle
        as="button"
        type="button"
        disabled={disabled}
        className={`form-select text-start filter-select${size === 'sm' ? ' form-select-sm' : ''}`}
        style={style}
      >
        {label}
      </Dropdown.Toggle>
      <Dropdown.Menu
        align={menuAlign}
        renderOnMount
        popperConfig={{ strategy: 'fixed', modifiers: [sameWidthModifier] }}
      >
        {searchable && (
          <div className="px-2 pt-1 pb-2" onClick={(e) => e.stopPropagation()}>
            <Form.Control
              autoFocus
              size="sm"
              type="text"
              placeholder={searchPlaceholder}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => e.stopPropagation()}
            />
          </div>
        )}
        <div style={{ maxHeight: 260, overflowY: 'auto' }}>
          {filtered.length === 0 ? (
            <div className="px-3 py-2 text-muted small">{noResultsText}</div>
          ) : (
            filtered.map((o) => (
              <Dropdown.Item
                eventKey={String(o.value)}
                key={String(o.value)}
                active={String(o.value) === String(value)}
              >
                {o.label}
              </Dropdown.Item>
            ))
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
